<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">{{
        $t("history.detail")
      }}</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <a-form :layout="formLayout">
              <a-form-item
                v-for="key in Object.keys(details)"
                :key="key"
                :label="key"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <span v-if="key == 'created'">{{
                  details[key] 
                }}</span>
                <span v-else>{{ details[key] }}</span>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    return {
      loading: false,
      details: {},
      formLayout: "horizontal",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      loading: false,
      coin: "",
      bool:false
    };
  },
  methods: {
    loadDetail() {
      this.api("admin/matched?action=detail&id=" + this.$route.params.id).then(
        res => {
          this.details = res;
        //   this.bool=true;
        }
      );
    },
    updateStatus() {
      this.loading = true;
      this.api("admin/transaction", {
        status: this.details.status,
        id: this.$route.params.id,
        paid: parseInt(this.paid)
      })
        .then(res => {
          console.log(res);
        })
        .finally(e => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.loadDetail();
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : {};
    }
  },
  mixins: [api, helper]
};
</script>
<style></style>
